export default __webpack_public_path__ + "static/prpl-8a3f893317594d6cee8dee9eb87dc196.png";